import { c as _c } from "react/compiler-runtime";
import { Menu, MenuItem } from "@flat-ui";
import { FilterChip } from "@components/common/faro-table/faro-table-filter/filter-chip";
import { FilterChipDropdownItem } from "@components/common/faro-table/faro-table-filter/filter-chip-dropdown-item";
import { FilterChipSearch } from "@components/common/faro-table/faro-table-filter/filter-chip-search";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { Box } from "@mui-wrapper";
import { useMemo, useState } from "react";
/** A chip to show for grouping set of filters. The children is the content shown after clicking on a chip */
export function DropdownFilterChip(t0) {
  const $ = _c(60);
  const {
    filteredColumn,
    label,
    items,
    shouldShowSearchBox,
    shouldShowCheckbox,
    shouldShowCheckIconOnRight: t1,
    shouldAllowLabelTranslation: t2,
    tableType,
    size: t3,
    isLoading: t4,
    onOpen
  } = t0;
  const shouldShowCheckIconOnRight = t1 === undefined ? false : t1;
  const shouldAllowLabelTranslation = t2 === undefined ? false : t2;
  const size = t3 === undefined ? "small" : t3;
  const isLoading = t4 === undefined ? false : t4;
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchText, setSearchText] = useState("");
  const dropdownWidth = size === "small" ? "230px" : "350px";
  let t5;
  if ($[0] !== items || $[1] !== searchText) {
    const search = searchText.trim().toLowerCase();
    t5 = Object.values(items).filter(item => [item.label, ...(item.searchTerms ?? [])].some(value => value.toLowerCase().includes(search)));
    $[0] = items;
    $[1] = searchText;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const filterItems = t5;
  const {
    getFilterIdsForColumn,
    updateFilterItem
  } = useFilterQueryParams();
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== anchorEl || $[4] !== dropdownWidth || $[5] !== filterItems || $[6] !== filteredColumn || $[7] !== getFilterIdsForColumn || $[8] !== label || $[9] !== onOpen || $[10] !== searchText || $[11] !== shouldAllowLabelTranslation || $[12] !== shouldShowCheckIconOnRight || $[13] !== shouldShowCheckbox || $[14] !== shouldShowSearchBox || $[15] !== tableType || $[16] !== updateFilterItem) {
    const activeFilterIds = getFilterIdsForColumn(filteredColumn);
    const onOptionClicked = function onOptionClicked(filterId) {
      updateFilterItem({
        tableType,
        filteredColumn,
        filterId,
        shouldReplaceFilterInColumn: !shouldShowCheckbox
      });
      setSearchText("");
    };
    T1 = Box;
    t13 = "div";
    const t15 = !!anchorEl;
    let t16;
    if ($[28] !== onOpen) {
      t16 = event => {
        setAnchorEl(event.currentTarget);
        onOpen?.();
      };
      $[28] = onOpen;
      $[29] = t16;
    } else {
      t16 = $[29];
    }
    if ($[30] !== filteredColumn || $[31] !== label || $[32] !== t15 || $[33] !== t16) {
      t14 = <FilterChip filteredColumn={filteredColumn} label={label} shouldHaveDropdown={true} isDropdownOpen={t15} onClick={t16} />;
      $[30] = filteredColumn;
      $[31] = label;
      $[32] = t15;
      $[33] = t16;
      $[34] = t14;
    } else {
      t14 = $[34];
    }
    T0 = Menu;
    t6 = anchorEl;
    t7 = !!anchorEl;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = () => setAnchorEl(null);
      $[35] = t8;
    } else {
      t8 = $[35];
    }
    t9 = dropdownWidth;
    if ($[36] !== dropdownWidth) {
      t10 = {
        paper: {
          sx: {
            width: dropdownWidth,
            maxHeight: "330px",
            overflowY: "auto"
          }
        }
      };
      $[36] = dropdownWidth;
      $[37] = t10;
    } else {
      t10 = $[37];
    }
    if ($[38] !== searchText || $[39] !== shouldShowSearchBox) {
      t11 = shouldShowSearchBox && <FilterChipSearch searchText={searchText} setSearchText={setSearchText} onEscape={() => {
        setAnchorEl(null);
        setSearchText("");
      }} />;
      $[38] = searchText;
      $[39] = shouldShowSearchBox;
      $[40] = t11;
    } else {
      t11 = $[40];
    }
    t12 = filterItems.map(item_0 => <FilterChipDropdownItem key={item_0.id} filterItem={item_0} isItemSelected={activeFilterIds.includes(item_0.id)} onItemClicked={onOptionClicked} shouldShowCheckbox={shouldShowCheckbox} shouldShowCheckIconOnRight={shouldShowCheckIconOnRight} shouldAllowLabelTranslation={shouldAllowLabelTranslation} />);
    $[3] = anchorEl;
    $[4] = dropdownWidth;
    $[5] = filterItems;
    $[6] = filteredColumn;
    $[7] = getFilterIdsForColumn;
    $[8] = label;
    $[9] = onOpen;
    $[10] = searchText;
    $[11] = shouldAllowLabelTranslation;
    $[12] = shouldShowCheckIconOnRight;
    $[13] = shouldShowCheckbox;
    $[14] = shouldShowSearchBox;
    $[15] = tableType;
    $[16] = updateFilterItem;
    $[17] = T0;
    $[18] = T1;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
    $[22] = t13;
    $[23] = t14;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    T0 = $[17];
    T1 = $[18];
    t10 = $[19];
    t11 = $[20];
    t12 = $[21];
    t13 = $[22];
    t14 = $[23];
    t6 = $[24];
    t7 = $[25];
    t8 = $[26];
    t9 = $[27];
  }
  let t15;
  if ($[41] !== filterItems.length || $[42] !== isLoading || $[43] !== label) {
    t15 = (isLoading || filterItems.length === 0) && <MenuItem label={isLoading ? `Loading the ${label.toLowerCase()}...` : `No ${label.toLowerCase()} found!`} sx={{
      pointerEvents: "none",
      textWrap: "wrap"
    }} />;
    $[41] = filterItems.length;
    $[42] = isLoading;
    $[43] = label;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== T0 || $[46] !== t10 || $[47] !== t11 || $[48] !== t12 || $[49] !== t15 || $[50] !== t6 || $[51] !== t7 || $[52] !== t8 || $[53] !== t9) {
    t16 = <T0 anchorEl={t6} open={t7} onClose={t8} minWidth={t9} slotProps={t10}>{t11}{t12}{t15}</T0>;
    $[45] = T0;
    $[46] = t10;
    $[47] = t11;
    $[48] = t12;
    $[49] = t15;
    $[50] = t6;
    $[51] = t7;
    $[52] = t8;
    $[53] = t9;
    $[54] = t16;
  } else {
    t16 = $[54];
  }
  let t17;
  if ($[55] !== T1 || $[56] !== t13 || $[57] !== t14 || $[58] !== t16) {
    t17 = <T1 component={t13}>{t14}{t16}</T1>;
    $[55] = T1;
    $[56] = t13;
    $[57] = t14;
    $[58] = t16;
    $[59] = t17;
  } else {
    t17 = $[59];
  }
  return t17;
}